import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/servers",
    name: "Server",
    component: () => import("../views/Server.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/economy",
    name: "ServerEco",
    component: () => import("../views/ServerEco.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/accounts",
    name: "Account",
    component: () => import("../views/Account.vue"),
    meta: {
      auth: true,
    },
  },
  {
    path: "/events",
    name: "Event Winners",
    component: () => import("../views/EventWinners.vue"),
    meta: {
      // auth: true
    },
  },
  {
    path: "/gm-events",
    name: "GM Events View",
    component: () => import("../views/GM/EventView.vue"),
  },
  {
    path: "/gm-actions",
    name: "GM Actions",
    component: () => import("../views/GM/Actions.vue"),
  },
  {
    path: "/gm-announcements",
    name: "GM Announcements",
    component: () => import("../views/GM/Announcements.vue"),
  },
  {
    path: "/faq",
    name: "Faq",
    component: () => import("../views/Faq.vue"),
    meta: {
      auth: true,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
